<section class="approve-comment-dialog">
    <div class="uscb-layout-row uscb-bg-primary uscb-color-white">
        <span class="vcenter uscb-flex usbc-padding-LR-10">
            @if (!fullCaseID?.slice(16).includes('OM-')) {
            <ng-container>
                SEND {{(action === 'APPROVAL') ? 'APPROVAL' : 'REJECTION'}}
            </ng-container>
            }
        </span>
        <span class="vcenter">
            <mat-icon (click)="close(true)" (keyup.enter)="close(true)" tabindex="0" aria-hidden="false">close</mat-icon>
        </span>
    </div>

    <form [formGroup]="formGroup" (ngSubmit)="onSubmit()">
        @if (!isSuccess()) {
        <mat-dialog-content>
            <div class="my-dialog-content">
                @if (action !== 'APPROVAL') {
                <div class="dialog-content-padding">
                    <textarea class="uscb-width-100" name="comment" id="comment" rows="3" formControlName="comment" id="comment"
                        cdkTextareaAutosize #autosize="cdkTextareaAutosize" cdkAutosizeMinRows="3" cdkAutosizeMaxRows="5"
                        placeholder="Enter Your Reason For Rejection Here (Optional)" tabindex="0">
                </textarea>
                    <div class="ecorr-padding-TOP-sm uscb-padding-L-2 uscb-font-sm">
                        <b>Note:</b>
                        Any messages submitted with HTML will be converted to plain text.
                    </div>
                </div>
                }
                <div class="indent-txt uscb-margin-R-30">
                    <div>
                        @if (hasError()) {
                        <mat-error>{{errorMessage()}}</mat-error>
                        }
                    </div>
                </div>
                <div class="dialog-content-padding">
                    <div class="uscb-font-1x uscb-padding-L-2">
                        Are you sure you would like to {{ (action === 'APPROVAL') ? 'approve' : 'reject'}} survey card access for
                        {{requestEmail}}?
                    </div>
                </div>
            </div>
        </mat-dialog-content>
        }

        @if (isSubmitting()) {
        <div class="uscb-transparent-button uscb-text-align-center">
            PLEASE WAIT... &nbsp;&nbsp; <i class="fa fa-spinner fa-spin"></i>
        </div>
        }

        @if (isSuccess()) {
        <div class="uscb-text-align-center uscb-margin-T-15">
            Your response has been recorded.
        </div>
        }

        @if (!isSuccess()) {
        <mat-dialog-actions align="center" class="uscb-layout-row uscb-layout-align-center-center">
            <button class="uscb-secondary-button" [disabled]="isSubmitting()" type="button" (click)="cancel()" (keyup.enter)="cancel()" tabindex="0">
                <i class="fa fa-minus-circle"></i>&nbsp;No</button>
            <div class="uscb-margin-5"></div>
            <button [disabled]="isSubmitting() || formGroup.invalid" class="uscb-primary-button" type="submit" tabindex="0">
                @if (!isSubmitting()) {
                <ng-container class="md-subhead">
                    <i class="fa fa-check-circle"></i>&nbsp;Yes</ng-container>
                }
                @if (isSubmitting()) {
                <ng-container>PLEASE WAIT...</ng-container>
                }
            </button>
        </mat-dialog-actions>
        }
    </form>
</section>